import { useEffect } from 'react';
import qs from 'qs';
import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import { StatisticsRedirectPath } from 'utils/constants/app/general';
import { STATISTICS_LANG } from 'utils/constants/languages/language-format';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { getWithLangMountPath } from 'utils/generic/route-manipulation';
import { storageKeyName } from 'utils/generic/storage-key-name';

export const RedirectFromStatistics = () => {
  useEffect(() => {
    if (window.location.hash.includes(StatisticsRedirectPath)) {
      const searchParams = qs.parse(
        window.location.hash.slice(window.location.hash.indexOf('?')),
        {
          ignoreQueryPrefix: true
        }
      );

      LocalStorage.setItem(
        storageKeyName('sportsbook', 'FROM_STATISTICS'),
        JSON.stringify(searchParams)
      );

      if (searchParams) {
        const lang =
          Object.keys(STATISTICS_LANG).find(
            key => STATISTICS_LANG[key] === searchParams.language
          ) || '';

        if (searchParams?.type && +searchParams?.type === 1) {
          window.location.href = getWithLangMountPath(
            `${SpringConfigs.PAGE_URLS.live}`,
            lang
          );
        } else {
          window.location.href = getWithLangMountPath(
            `${SpringConfigs.PAGE_URLS.prematch}`,
            lang
          );
        }
      }
    }
  }, []);

  return null;
};
